import React, { useState, useEffect, useRef } from "react";
import { HeaderText, Button, Toast } from "../";
import { useOrderContext, useAppContext } from "../../contexts";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  setProductDetails,
} from "../../redux/slices";
import {
  productActionTypes,
} from "../../redux/utils";
import { capitalizeFirstLetter } from "../../Utilities/capitalizeFirstLetter";
import { useAPI, useHardCode } from "../../hooks";

export const SubReason = () => {
  const [isTextArea, setIsTextArea] = useState(true);
  const [returnReason, setReturnReason] = useState();
  const [returnSubReason, setReturnSubReason] = useState();
  const [reasonID, setReasonID] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const reasonDetailRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const settingState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME } = useHardCode();
  const storeConfigState = useSelector((state) => state.storeSettings);

  useEffect(() => {
    setReturnReason(productDetailsState.returnReason);
  }, []);
  useEffect(() => {
    setReturnSubReason(productDetailsState.returnReasonDesc);

    if(productDetailsState?.returnReasonDesc?.subreasons_free_text){
      if(productDetailsState?.returnReasonDesc?.subreasons_free_text_optional){
        setIsBtnDisabled(false);
      }
    }
  }, []);

  const showOtherReason = (closeTextBox) => {
    if (closeTextBox) {
      reasonDetailRef.current.value = "";
      setIsTextArea(false);
    } else {
      setIsTextArea(true);
    }
  };

  const buttonHandler = () => {
  
      setIsLoader(true);
      setIsBtnDisabled(true);
      if(returnSubReason?.subreasons_free_text){
        dispatch(
          setProductDetails({
            key: productActionTypes.SET_SUB_REASON_DETAILS,
            value: reasonDetailRef.current.value,
          })
        );
      } else {
        dispatch(
          setProductDetails({
            key: productActionTypes.SET_SUB_REASON_DETAILS,
            value: reasonID,
          })
        );
      }
      setIsBtnDisabled(false);
      navigate("/return");
  };

  const backHandler = () => {
    window.history.back();
  };

  const isReasonDetailEmpty = () => {
    if (reasonDetailRef?.current?.value?.length > 0) {
      setIsBtnDisabled(false);
    }  else {
      setIsBtnDisabled(true);
      if(productDetailsState?.returnReasonDesc?.subreasons_free_text){
        if(productDetailsState?.returnReasonDesc?.subreasons_free_text_optional){
          setIsBtnDisabled(false);
        }
      }
    }
  };

  return (
    <div className="saara-item-reason-container">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara-item-heading">
        <div>
          <Link to="" onClick={backHandler} className="backIcon">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
        </div>

        <HeaderText
          text="Reason details"
        />
        
      </div>
        <h2 className="saara-item-heading">
          {returnSubReason?.sub_reason_question}
        </h2>
      <div className="reason-main-container">
      {!returnSubReason?.subreasons_free_text ? (
        returnSubReason?.store_reasons.map((item) => (
          <div
            key={item}
            className={`reason_item ${reasonID === item && "active"}`}
            onClick={() => {
              setReasonID(item);
              setIsBtnDisabled(false);
            }}
          >
            <span>{capitalizeFirstLetter(item)}</span>
            <input
              className="return_option_radio radio_option"
              name="return_radio"
              type="radio"
              checked={reasonID === item}
            />
          </div>
        ))
      ) : null}
      {returnSubReason?.subreasons_free_text ? (
          <div className="reason_details">
            <label
              className={`${
                isTextArea
                  ? "reason_item reason_other"
                  : "reason_item  reason_details_info_text_height"
              }`}
              onClick={() => {
                showOtherReason();
              }}
            >
              write here

              {!SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female && (
                <span
                  className={`${
                    isTextArea ? "hide" : "reason_details_info_text"
                  }`}
                >
                  <br /> <br /> 
                </span>
              )}

              {/* Text Area */}
              <textarea
                ref={reasonDetailRef}
                maxLength="500"
                className={` ${
                  isTextArea ? "other__textarea show" : "other__textarea"
                }`}
                onKeyUp={(e) => {
                  isReasonDetailEmpty();
                }}
              ></textarea>
            </label>
          </div>
        ) : null}
      </div>

      <div className="btns">
        <div className=" btn__big_screen margin-right-20">
          <button
            className="saara_custom_btn saara__btn btn__back back-page"
            onClick={backHandler}
          >
            {storeConfigState?.themeConfig?.back_button_label}
          </button>
        </div>
        <div>
          <Button
            name={
              isLoader ? (
                <div
                  className="saara-spinner-border saara-spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                storeConfigState?.themeConfig?.continue_button_label
              )
            }
            onClick={buttonHandler}
            disabled={isBtnDisabled}
          />
        </div>
      </div>
    </div>
  );
};
